import { useQuery } from 'react-query'

// import { CarriersApi } from '../useContracts/api'
import { CarriersApi } from '../useCarriers/api'
import { QUERY_KEYS } from '../../api'

const useGetOrders = (filters?: any) => {
  const { data: orders, isLoading: ordersIsLoading } = useQuery([QUERY_KEYS.ORDERS, filters], () =>
    CarriersApi.getContractOrders({ filters }),
  )
  return {
    orders,
    ordersIsLoading,
  }
}

export default useGetOrders
